import {ModuleState} from '@fantasmagames/slot/src/common/ModuleState';
import {AvalancheReelsView} from '@fantasmagames/slot/src/modules/reels/avalanche/AvalancheReelsView';
import {AvalancheReelsModule} from '@fantasmagames/slot/src/modules/reels/avalanche/AvalancheReelsModule';
import {LogicEvents} from '@fantasmagames/slot/src/logic/LogicEvents';
import {AvalancheReelsEvents} from '@fantasmagames/slot/src/modules/reels/avalanche/AvalancheReelsEvents';

/**
 * here we're re-spinning (whatever this means in terms of the game)
 */
export class AvalancheRespinState extends ModuleState<AvalancheReelsView, AvalancheReelsModule> {
	protected _isWaitingForRespin: boolean = false;

	public onEnterState(): void {
	}

	public onLeaveState(): void {
	}

	protected setupEvents(): void {
		this.on(LogicEvents.RESPIN_RESPONSE, this.onRespinResponse);
		this.on(AvalancheReelsEvents.FILLING_VOIDS_FINISHED, this.onFillingVoidFinished);
	}

	protected onRespinResponse(): void {
		if (this._isWaitingForRespin) {
			this._isWaitingForRespin = false;
			this.startAddingNewSymbols();
		}
	}

	protected onFillingVoidFinished(): void {
		if (this.module.isRespinResponseReceived) {
			this.startAddingNewSymbols();
		} else {
			this._isWaitingForRespin = true;
		}
	}

	protected startAddingNewSymbols(): void {
		throw new Error('AvalancheRespinState::startAddingNewSymbols must be overridden');
	}

}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/reels/avalanche/states/AvalancheRespinState.ts